module.exports = __webpack_public_path__ + "static/media/kebab_menu_o.83fc0a83.svg";